import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

type AnalyticsCardProps = {
  title: string;
  value: string | number;
};

export const AnalyticsCard: React.FC<AnalyticsCardProps> = ({ title, value }) => {
  return (
    <Box
      bg="#FFFFFF"
      border="1px solid #EDEDED"
      borderRadius="16px"
      p={{ base: 4, md: 6 }}
      minW={{ base: "auto", md: "200px" }}
      w="100%"
      boxShadow="0 2px 8px rgba(0,0,0,0.04)"
    >
      <Flex direction="column" gap={2}>
        <Text fontSize={{ base: "xs", md: "sm" }} color="#6B7280">{title}</Text>
        <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="700" color="#4A2C2A">{value}</Text>
      </Flex>
    </Box>
  );
};

export default AnalyticsCard;
